import type { FC } from "react";

import type { ISelectedBundleOptionValue } from "@jti/magento";

import BundleOptionValue from "./BundleOptionValue";

export type BundleOptionProps = {
  categoryName: string;
  values: ISelectedBundleOptionValue[];
};

const BundleOption: FC<BundleOptionProps> = ({ categoryName, values }) => (
  <>
    {values.map((option) => {
      const { initial_price = option.price, presentation_price, product } = option?.presentation_info || {};
      let product_name = option.label;

      if (values.length > 1) {
        product_name = `${categoryName}: ${option.label}`;
      }

      return (
        <BundleOptionValue
          key={`${categoryName} - ${option.label}`}
          prices={{ initial_price, presentation_price }}
          quantity={option.quantity}
          imageUrl={product?.small_image?.url}
          product_name={product_name}
          tooltip_info={option?.presentation_info.product.tooltip_info}
          stock_status={option.presentation_info.product.stock_status}
        />
      );
    })}
  </>
);

export default BundleOption;
